import { Box, Typography, Divider } from "@mui/material";
import SectionNavTemplate from "../SectionNavTemplate";
import ProgressBar from "../ProgressBar";
import SectionContentTemplate from "../SectionContentTemplate";
import Button from "../../toolkit/ButtonV1";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import edit from "../../icons/edit.svg";
import { useState, useEffect } from "react";
import axios from "../../utils/fvAxios";
import BaseURL from "../../utils/base-uri.json";

export default function ({
  navWrapper: NavWrapper,
  navProps,
  contentProps,
  children,
  className,
  ml,
  percentComplete,
  leftLabel,
  rightLabel,
  NextId,
  IsSectionCompleted,
  modifiedData,
  addOrUpdateSection,
  refreshSectionList
}) {
  const section = navProps?.options.find((s) => s.id === navProps?.selected);
  const [isVisibleToggle, setIsVisibleToggle] = useState(section?.isVisible);
  useEffect(() => {
    setIsVisibleToggle(section?.isVisible);
  }, [navProps]);
  const switchVisibleHandler = async () => {
    let _section = {
      ChecklistSectionId: navProps?.selected,
      IsVisible: !isVisibleToggle,
    };

    const response = await axios.post(
      BaseURL.templateTool.UpdateChecklistSectionVisibility,
      _section
    );

    if (response.data?.responseCode === 100) {
      setIsVisibleToggle((prev) => !prev);
      refreshSectionList();
    } else if (response.data?.responseCode == -100) {
      console.error(response.data?.responseMessage, false);
    } else if (response.data?.responseCode == -200) {
      console.error(response.data);
    } else console.error(response.data);
  };

  return (
    <Box className={className}>
      {NavWrapper ? (
        <Box className="section-nav-container px-0">
          <div className="align-items-center border-bottom d-flex justify-content-between my-0 pb-4 pe-5 pt-2 px-4">
            <Box>
              <Tooltip title="Current Checklist Section">
                <Typography className="mx-2" style={{ fontWeight: "bold" }}>
                  {
                    navProps?.options.find((s) => s.id === navProps?.selected)
                      ?.text
                  }
                </Typography>
              </Tooltip>
            </Box>

            <div className="d-flex">
              <Box width={"50px"}>
                <Tooltip title="Edit">
                  <Typography className="mx-2">
                    <IconButton
                      aria-label="edit"
                      onClick={() =>
                        addOrUpdateSection(navProps?.selected ?? -1)
                      }
                    >
                      <img src={edit} alt="edit icon" />
                    </IconButton>
                  </Typography>
                </Tooltip>
              </Box>
              <Box width={"50px"}>
                <Tooltip
                  title={`${
                    navProps?.options.find((s) => s.id === navProps?.selected)
                      ?.isVisible
                      ? "Hide"
                      : "Show"
                  }`}
                >
                  <Typography className="mx-2">
                    <IconButton
                      aria-label="Visibility"
                      onClick={switchVisibleHandler}
                    >
                      {isVisibleToggle ? (
                        <VisibilityOff />                       
                      ) : (
                        <Visibility color="disabled" />
                      )}
                    </IconButton>
                  </Typography>
                </Tooltip>
              </Box>
            </div>
          </div>
          {navProps?.options?.length > 0 && (
            <SectionNavTemplate
              modifiedData={modifiedData}
              ml={ml}
              NextId={NextId}
              {...navProps}
            />
          )}
        </Box>
      ) : (
        navProps && (
          <SectionNavTemplate
            modifiedData={modifiedData}
            ml={ml}
            NextId={NextId}
            {...navProps}
          />
        )
      )}
      <SectionContentTemplate {...contentProps} style={{ minHeight: "400px" }}>
        {children}
      </SectionContentTemplate>
    </Box>
  );
}
